import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-11.5a4.5 4.5 0 0 1 9 0v8.5","key":"svg-0"}],["path",{"d":"M13 14l3 3l3 -3","key":"svg-1"}]]

/**
 * IconUTurnRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdS10dXJuLXJpZ2h0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDIwdi0xMS41YTQuNSA0LjUgMCAwIDEgOSAwdjguNSIgLz4KICA8cGF0aCBkPSJNMTMgMTRsMyAzbDMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/u-turn-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUTurnRight = createReactComponent('outline', 'u-turn-right', 'UTurnRight', __iconNode);

export default IconUTurnRight;